import React, { useRef, useState } from "react";
import {
  TranslationEnum,
  usePortalTranslation,
} from "../../../providers/TranslationProvider";
import { Autocomplete, Button, TextField } from "@mui/material";
import { ConfirmationPopUp } from "../../popup/confirmationPopUp";
import "./dbAndOutlet.css";
import {
  dbAndOutletLevel,
  DropDownStateData,
} from "../../../features/updateGeofence/updateGeofenceTypes";
import { convertDbAndOutletData, getDbAndOutletLevels, saveDbAndOutletData } from "../../../features/updateGeofence/updateGeofenceService";
import DbAndOutletDropDown from "../DbAndOutletDropDown/DbAndOutletDropDown";
import { popupType } from "../../../types/types";
import { GenericPopUp } from "../../popup/genericPopUp";
const DbAndOutlet = () => {
  const { translate } = usePortalTranslation();
  const [selectedLevel, setSelectedLevel] = useState<dbAndOutletLevel | null>(
    null
  );
  const [distance, setDistance] = useState<string>(""); // Initial state is an empty string
  const [confirmationPopUp, setConfirmationPopUp] = useState(false);
  const [popUpMessage, setPopUpMessage] = useState<string>("");
  const [inputValues, setInputValues] = useState<
    Record<number, DropDownStateData>
  >({});
  const [lastUpdatedLevel, setLastUpdatedLevel] = useState<number>(-1);
  const [genericModalState, setGenericModalState] = useState(false);
  const [genericModalMessage, setGenericModalSMessage] = useState("");
  const [genericModaltype, setGenericModalType] = useState<popupType>("Error");
  const popUpSuccessMethod = useRef<any>();
  const dbAndOutletLevels: dbAndOutletLevel[] = getDbAndOutletLevels();
  const openPopUp = (message: string, modalType: popupType) => {
    setGenericModalSMessage(message);
    setGenericModalState(true);
    setGenericModalType(modalType);
  };
  const handleDistanceInputChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const value = Number(event.target.value);
    if (!isNaN(value)) {
      setDistance(event.target.value);
    }
  };
  const updateConfirmationPopData = (message: string, methodHelper: any) => {
    popUpSuccessMethod.current = methodHelper;
    setPopUpMessage(message);
  };
  const handleDbAndOutletSubmitRequest = async () => {
    //convert the input in the required fomat 
    const convertedData = convertDbAndOutletData(inputValues,distance);
    try{
      const response = await saveDbAndOutletData(convertedData);
      if(response.status===200){
        openPopUp("Data saved successfully", "Success");
      }
      else{
        openPopUp("Error saving data", "Error");
      }
    }
    catch(e){
      openPopUp("Error saving data", "Error");
    }
    //call the funciton saveDbAndOutletData
    //show popus if resopns.200 else popup error
  };
  const resetTheDropDowns = () => {
    setInputValues({});
    setLastUpdatedLevel(-1);
    setDistance("");
  };
  const checkForValidInput = (): boolean => {
    if (!selectedLevel) return false;

    // Check if all levels up to the selected level exist
    for (let i = 0; i <= selectedLevel.level; i++) {
      if (!inputValues[i]) {
        return false;
      }
    }

    // Check if no levels greater than the selected level exist
    for (let i = selectedLevel.level + 1; i < dbAndOutletLevels.length; i++) {
      if (inputValues[i]) {
        return false;
      }
    }

    if (!distance || isNaN(Number(distance))) {
      return false;
    }

    return true;
  };
  const handleSave = () => {
    if (checkForValidInput()) {
      // Save logic here
      setConfirmationPopUp(true);
      updateConfirmationPopData(
        translate(TranslationEnum.common_portal,"Are you sure want to save ?"),
        handleDbAndOutletSubmitRequest
      );
    } else {
      openPopUp(translate(TranslationEnum.common_portal,"Please fill all the fields"), "Error");
    }
  };

  const handleCancel = () => {
    // Cancel logic here
    setConfirmationPopUp(true);
    updateConfirmationPopData(
      translate(TranslationEnum.common_portal,"Are you sure want to cancel ? All unsaved changes will be lost!"),
      resetTheDropDowns
    );
  };
  const updateInputValues = (
    levelInfo: dbAndOutletLevel,
    data: DropDownStateData
  ) => {
    // Use the functional form of state updates to avoid stale state issues
    setInputValues((prevValues) => {
      // Create a new object to avoid mutating the existing state
      const updatedValues = { ...prevValues, [levelInfo.level]: data };

      // Filter out levels that are greater than `lastUpdatedLevel`
      const filteredValues = Object.keys(updatedValues).reduce(
        (acc: Record<number, DropDownStateData>, key) => {
          const numericKey = Number(key);
          if (numericKey <= levelInfo.level) {
            acc[numericKey] = updatedValues[numericKey];
          }
          return acc;
        },
        {} as Record<number, DropDownStateData>
      );

      return filteredValues;
    });

    // Update the last updated level
    setLastUpdatedLevel(levelInfo.level);
  };
  const resetInputValues = (level: number) => {
    setInputValues((prevValues) => {
      // Create a new object to avoid mutating the existing state
      const updatedValues = { ...prevValues };

      // Filter out levels that are greater than `lastUpdatedLevel`
      const filteredValues = Object.keys(updatedValues).reduce(
        (acc: Record<number, DropDownStateData>, key) => {
          const numericKey = Number(key);
          if (numericKey < level) {
            acc[numericKey] = updatedValues[numericKey];
          }
          return acc;
        },
        {} as Record<number, DropDownStateData>
      );

      return filteredValues;
    });
    setLastUpdatedLevel(level - 1);
  };
  return (
    <div className="updateGeofence-dbAndOutlet-wrapper">
      <Autocomplete
        className="updateGeofence-dbAndOutlet-levelSelect-dropdown"
        disablePortal
        options={dbAndOutletLevels}
        getOptionLabel={(option) => option.label} // Use 'label' for displaying
        onChange={(event, newValue) => {
          if(newValue)
            setSelectedLevel(newValue); // Update state with the selected level object
          else{
            resetTheDropDowns();
            setSelectedLevel(null);
          }
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label={translate(TranslationEnum.geofence, "Level")} // Provide a label for the input
          />
        )}
      />
      {selectedLevel && (
        <div className="updateGeofence-dbAndOutlet-dropdowns-wrapper">
          {dbAndOutletLevels.map((item) => {
            if (item.level <= selectedLevel.level) {
              return (
                <DbAndOutletDropDown
                  key={item.label}
                  currentLevel={item}
                  higherLevelInputValues={inputValues}
                  updateInputValues={updateInputValues}
                  lastUpdatedLevel={lastUpdatedLevel}
                  resetInputValues={resetInputValues}
                />
              );
            }
            return null;
          })}
        </div>
      )}
      <TextField
        className="updateGeofence-dbAndOutlet-distance-input"
        label={translate(TranslationEnum.geofence, "Distance")} // Translate each region
        variant="outlined"
        type="text" // Ensure the input type is number
        value={distance} // Controlled input value
        onChange={handleDistanceInputChange} // Handle changes
        InputProps={{
          inputProps: {
            min: 0,
            inputMode: "numeric",
            pattern: "[0-9]*", // This won't work with input type="number"
          },
        }}
      />
      <div className="updateGeofence-buttons-wrapper">
        <Button variant="contained" onClick={handleSave}>
          {translate(TranslationEnum.common, "Save")}
        </Button>
        <Button variant="contained" onClick={handleCancel}>
          {translate(TranslationEnum.common, "Cancel")}
        </Button>
      </div>
      <ConfirmationPopUp
        openConfirmModal={confirmationPopUp}
        message={popUpMessage}
        setOpenConfirmModal={() => {
          setConfirmationPopUp(false);
        }}
        successMethod={popUpSuccessMethod.current}
      />
      <GenericPopUp
        type={genericModaltype}
        message={genericModalMessage}
        openGenericModal={genericModalState}
        setOpenGenericModal={() => {
          setGenericModalState(false);
        }}
      />
    </div>
  );
};

export default DbAndOutlet;
